import { useDispatch } from "react-redux";
import { setUser } from "../Store/userSlice";

export const useLogout = () => {
  const dispatch = useDispatch();

  return () => {
    localStorage.removeItem("Token");
    localStorage.removeItem("account");
    dispatch(setUser(null));
    window.location.href="/";
  };
};
